import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';

import { ISettingsSaveTonerBehaviorModel, ISettingsSaveTonerDefaultRuleModel, ISettingsSaveTonerLicensingModel, IUpdateSettingsSaveTonerBehaviorCommand, IUpdateSettingsSaveTonerDefaultRuleCommand, IUpdateSettingsSaveTonerLicensingCommand } from './settings-save-toner.model';

@Injectable({
    providedIn: 'root',
})
export class SettingsSaveTonerService {
    public behaviorUpdated$: Subject<boolean> = new Subject<boolean>();
    public licensingUpdated$: Subject<boolean> = new Subject<boolean>();
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private loggerService: LoggerService,
        private translation: NDDTranslationService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-save-toner`;
    }

    public getLicensing(): Observable<ISettingsSaveTonerLicensingModel> {
        return this.http.get<ISettingsSaveTonerLicensingModel>(`${ this.apiUrl }/licensing`);
    }

    public updateLicensing(enabled: boolean): Observable<boolean> {
        const command: IUpdateSettingsSaveTonerLicensingCommand = { enabled };

        return this.http.post<boolean>(`${ this.apiUrl }/licensing`, command)
            .pipe(tap(() => {
                this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')]);
                this.licensingUpdated$.next(enabled);
            }));
    }

    public getBehavior(): Observable<ISettingsSaveTonerBehaviorModel> {
        return this.http.get<ISettingsSaveTonerBehaviorModel>(`${ this.apiUrl }/behavior`);
    }

    public updateBehavior(enabled: boolean): Observable<boolean> {
        const command: IUpdateSettingsSaveTonerBehaviorCommand = { enabled };

        return this.http.post<boolean>(`${ this.apiUrl }/behavior`, command)
            .pipe(tap(() => {
                this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')]);
                this.behaviorUpdated$.next(command.enabled);
            }));
    }

    public getDefaultRule(): Observable<ISettingsSaveTonerDefaultRuleModel> {
        return this.http.get<ISettingsSaveTonerDefaultRuleModel>(`${ this.apiUrl }/default-rule`);
    }

    public updateDefaultRule(enabled: boolean, savingPercentage: number): Observable<boolean> {
        const command: IUpdateSettingsSaveTonerDefaultRuleCommand = { enabled, savingPercentage };

        return this.http.post<boolean>(`${ this.apiUrl }/default-rule`, command)
            .pipe(tap(() => this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')])));
    }
}
